import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMixIngredientsGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M15.46 12.74a1.42 1.42 0 1 0 0-2.84 1.42 1.42 0 0 0 0 2.84ZM27.8 14.64c1.83 0 3.32-1.49 3.32-3.32C31.12 9.49 29.63 8 27.8 8c-1.83 0-3.32 1.49-3.32 3.32 0 1.83 1.49 3.32 3.32 3.32Zm0-5.14c1 0 1.82.82 1.82 1.82s-.82 1.82-1.82 1.82-1.82-.82-1.82-1.82.82-1.82 1.82-1.82ZM17.63 22.17c.41 0 .75-.34.75-.75 0-1 .82-1.82 1.82-1.82s1.82.82 1.82 1.82c0 .41.34.75.75.75s.75-.34.75-.75c0-1.83-1.49-3.32-3.32-3.32-1.83 0-3.32 1.49-3.32 3.32 0 .41.34.75.75.75ZM32.54 20.98a1.419 1.419 0 1 0-1.42-1.42c-.01.79.63 1.42 1.42 1.42ZM39.78 23.55a.75.75 0 0 0-.53-.22H11.79c-.41 0-.75.34-.75.75s.34.75.75.75h26.69C38.06 32.43 31.72 38.5 24 38.5c-7.97 0-14.48-6.47-14.5-14.42a.749.749 0 1 0-1.5 0C8.03 32.86 15.2 40 24 40s15.97-7.14 16-15.92c0-.2-.08-.39-.22-.53Z",
    fill: "currentColor"
  }));
}

export { SvgMixIngredientsGlyphSecondary as default };
